'use strict';
import * as $j_app$002epages$002e$002dDocument$002dTemplates$002dCreate$002dPage$0024$002dArgs from "./app.pages.-Document-Templates-Create-Page$-Args.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument(docId) {
  this.M6 = null;
  this.M6 = docId;
}
export { $c_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument as $c_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument };
$p = $c_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument.prototype = new $j_app$002epages$002e$002dDocument$002dTemplates$002dCreate$002dPage$0024$002dArgs.$h_Lapp_pages_DocumentTemplatesCreatePage$Args();
$p.constructor = $c_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument;
/** @constructor */
function $h_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument() {
}
export { $h_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument as $h_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument };
$h_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument)) {
    var x = this.M6;
    var x$2 = x$0.M6;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "BasedOnDocument";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.M6;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "docId";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 1;
});
function $isArrayOf_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kg)));
}
export { $isArrayOf_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument as $isArrayOf_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument };
var $d_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument, "app.pages.DocumentTemplatesCreatePage$Args$BasedOnDocument", ({
  kg: 1,
  kf: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument as $d_Lapp_pages_DocumentTemplatesCreatePage$Args$BasedOnDocument };
//# sourceMappingURL=app.pages.-Document-Templates-Create-Page$-Args$-Based-On-Document.js.map
